import React from "react";
import aboutFront from "../assets/Vector 73 (1).svg";
import core1 from "../assets//Image-1.png";
import ravi from "../assets/Image.png";
import core2 from "../assets/1670913245726 3.svg";
import core4 from "../assets/Image (4).svg";
import "../components/OurTeam/ourteam.scss";
import { Link } from "react-router-dom";

export const coreTeam = [
  {
    id: 1,
    name: "Mahendra Khandelwal",
    title: "Managing Director",
    image: core1,
    desc: `With an esteemed career spanning more than three decades, Mr. Mahender Khandelwal embarked on his journey as a Chartered Accountant in 1991, evolving into a seasoned senior management and financial professional renowned for his expertise in structuring and financing through diverse debt and equity instruments. His proficiency extends to adeptly managing and orchestrating successful turnarounds for special situations and insolvency scenarios across a wide array of industries. Notably, he has led the restructuring and resolution of over 100 large corporations spanning sectors including Iron and Steel, Stainless Steel, Pharma, Hotels, and NBFCs, showcasing his exceptional leadership in navigating complex financial challenges.
With a wealth of experience, Mr. Khandelwal boasts extensive industry expertise, enabling him to effectively navigate intricate regulatory landscapes with finesse. His adeptness in handling regulatory agencies such as RBI, SEBI, GST, CBI, SFIO, and ED underscores his commitment to ensuring compliance and strategic financial governance. Furthermore, his sector-specific acumen spans across diverse domains including Iron and Steel, Pharma, Power and Infrastructure, Auto Component, Textile, Education, Construction, and Real Estate, reflecting his holistic approach towards addressing multifaceted financial complexities with precision and efficiency`,
  },
  {
    id: 2,
    name: "Ravi Kant Baheti",
    title: "Partner",
    image: ravi,
    desc: `With over 25 years in the BFSI sector, Mr. Ravi Kaant Baheti is an accomplished Chartered Accountant, served as CFO, Financial Controller, and Company Secretary across NBFCs, Insurance, HFCs, Merchant Banking, Mutual Funds, Securities Brokerage, and Wealth Management. He excels in financial planning, compliance, strategic relationship-building, and operational efficiency, evidenced by raising substantial funding, leading successful ERP implementations, and streamlining MIS reporting. Ravi's multifaceted management skills encompass audits, fund raising, board meetings, and legal matters. He is committed to continuous improvement, enhancing month-end reporting timeliness, and aligning with senior management to achieve corporate goals.`,
  },
  {
    id: 3,
    name: "Mohit Bansal",
    title: "Partner",
    image: core2,
    desc: `With over 12 years of experience in Technology & Software Development, Mr. Mohit Bansal, an NSIT alumni in IT, serves as the Founder & MD at Credhub Technologies & Co-Founder at Phocket Infotech Private Limited. Spearheading a fintech startup specializing in short-term loans, he has contributed to prominent brands like Magicbricks, Quara Holding, and Wasalt. Mohit brings robust expertise in Fintech Products encompassing eWallet, Digital Lending Platform, Real-Estate & Valuation Platform, and Payments & Home Finance digital products.`,
  },
  {
    id: 4,
    name: "Prateek Khandelwal",
    title: "Partner",
    image: core4,
    desc: "Prateek Khandelwal, a veteran Chartered Accountant with 16+ years of experience in the FMCG industry, boasts a distinguished career leading Controlling roles, FP&A, and Supply Chain Finance functions at esteemed companies like Vedanta, PepsiCo, Asian Paints, and Mondelez International (Cadbury). Most recently, he served as Director, Supply Chain Finance at OLA Electric. Prateek excels in securing Capex funding, driving automation in financial processes, and developing Strategic financial plans that propel business growth. His expertise in financial planning, analysis, and leadership has earned him a reputation as a trusted advisor to CXOs.",
  },
];

const OurTeam = () => {
  return (
    <div className="container our-team">
      <div className="our-team-image" style={{ position: "relative" }}>
        <img
          src={aboutFront}
          alt="Team Banner"
          style={{ objectFit: "cover" }}
        />
        <h4 className="centered">Our Team And Board Advisory</h4>
        <div className="team mb-0">
          <h3 className="text-center mb-0">Our Team</h3>
        </div>
      </div>

      <div className="row core-team mt-5">
        <h2 className="fw-bolder mb-4">Core Team</h2>
        {coreTeam.map((member, index) => (
          <div className="col-lg-3 col-md-6 core-team1 mb-5">
            <Link to={"/core1:id"} key={index} state={{ id: member.id }}>
              <img className="member" src={member.image} alt={member.name} />
              <h5 className="text-center mt-3 mb-0">{member.name}</h5>
              <p className="text-center mb-0">{member.title}</p>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurTeam;
